import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form, InputGroup, Table } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination';
import DeleteModal from '../../components/DeleteModal';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import ViewContact from '../../components/contact/ViewContact';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';
import MyDateRangePicker from '../../components/MyDateRangePicker';

function ContactList() {

    const [contactList, setContactList] = useState([])
    const [search, setSearch] = useState('')
    const [pagination, setPagination] = useState({
        currentPage: 1,
        limit: 10,
        totalPages: 1,
    })
    const [loading, setLoading] = useState(false)
    const [searchTimeout, setSearchTimeout] = useState(null)

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    // const [startDate, setStartDate] = useState(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
    // const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [sortBy, setSortBy] = useState('');


    const fetchContacts = useCallback(async (page = 1, limit = 10, searchQuery = '', from = '', to = '', sort = '') => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/contacts/list`, {
                params: {
                    page,
                    limit,
                    search: searchQuery,
                    startDate: from,
                    endDate: to,
                    sort: sort
                }
            });
            if (response.data.success) {
                setContactList(response.data.data);
                setPagination(response.data.pagination);
            } else {
                setContactList([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            }
        } catch (error) {
            setContactList([]);
            setPagination(prev => ({
                ...prev,
                currentPage: 1,
                totalPages: 1,
                totalItems: 0
            }));
        } finally {
            setLoading(false);
        }
    }, [])
    useEffect(() => {
        fetchContacts(pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy);
    }, [pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy, fetchContacts]);

    const handleSearch = useCallback((e) => {
        const value = e.target.value;
        setSearch(value);

        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        const timeoutId = setTimeout(() => {
            fetchContacts(1, pagination.limit, value);
        }, 15000);

        setSearchTimeout(timeoutId);
    }, [pagination.limit, searchTimeout, fetchContacts]);

    const handleLimitChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setPagination(prev => ({ ...prev, limit: newLimit, currentPage: 1 }));
    };
    const handleDelete = async (id) => {
        try {
            setLoading(true);

            const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/contact/delete/${id}`);
            if (response.data.success) {
                CustomToast.success(response.data.message);
                fetchContacts(pagination.currentPage, pagination.limit, search, startDate, endDate, sortBy);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };
    const handleDateRangeChange = (start, end) => {
        setStartDate(start);
        setEndDate(end);
    };
    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortBy(value);
        fetchContacts(1, pagination.limit, search, startDate, endDate, value);
    };
    return (
        <Layout title="Contact List">
            <main>
                <div className="card page-card">

                    <div className="card-header d-xl-flex justify-content-between align-items-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <div className='d-flex align-items-center gap-3'>
                                <p>Show</p>
                                <Form.Select aria-label="Default select example" value={pagination.limit} onChange={handleLimitChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </Form.Select>
                                <p>entries</p>
                            </div>
                            <div className='d-flex align-items-center gap-3 ms-3'>
                                <p>Sort by</p>
                                <Form.Select
                                    aria-label="Sort options"
                                    value={sortBy}
                                    onChange={handleSortChange}
                                    style={{ minWidth: '180px' }}
                                >
                                    <option value="email_asc">Email (A-Z)</option>
                                    <option value="email_desc">Email (Z-A)</option>
                                    <option value="newest">Newest First</option>
                                    <option value="oldest">Oldest First</option>
                                </Form.Select>
                            </div>
                        </div>
                        <div className='d-flex align-items-start align-items-md-center justify-content-end gap-2 flex-column flex-wrap flex-md-row mt-3 mt-xl-0'>
                            <MyDateRangePicker onDateChange={handleDateRangeChange} initialStartDate={startDate} initialEndDate={endDate} />
                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>

                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="overflow-auto">
                            <Table className='vertical-align'>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Platform</th>
                                        <th>Message</th>
                                        <th>Enquiry Date</th>
                                        <th width="100" className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>{loading ?
                                    (<tr>
                                        <td colSpan="7" className="text-center">
                                            <Loader />
                                        </td>
                                    </tr>) : contactList.length > 0 ? (
                                        contactList.map((contact, index) => (
                                            <tr key={contact._id}>
                                                <td width="40">
                                                    <p className='mb-0'>{(pagination.currentPage - 1) * pagination.limit + index + 1}</p>
                                                </td>
                                                <td className='table-td-130'>{contact.name ? contact.name : "-"}</td>
                                                <td>{contact.email ? contact.email : "-"}</td>
                                                <td className='table-td-130'>{contact.phone ? contact.phone : "-"}</td>
                                                <td>{contact.flag === "contact" ? "Mobile" : contact.flag === "web" ? "Website" : "-"}</td>
                                                <td className='table-td-300'>{contact.message ? contact.message : "-"}</td>
                                                <td className='table-td-130'>{contact.createdAt ? new Date(contact.createdAt).toLocaleString() : "-"}</td>
                                                <td>
                                                    <div className='d-flex justify-content-center gap-2'>
                                                        <ViewContact contact={contact} />
                                                        <DeleteModal
                                                            onConfirm={() => handleDelete(contact._id)}
                                                            loading={loading}
                                                            flag={"contact"}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                <NoDateFound />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalPages}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))} />
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default ContactList